module.exports = __webpack_public_path__ + "static/media/hyperthermia_bad.13ce0885.svg";